import { createContext } from 'react';
import type { ScreenMode, Theming } from './const';

export const ThemeContext = createContext<
  | {
      theme: NonNullable<Theming['theme']>;
      screenMode: ScreenMode;
    }
  | undefined
>(undefined);
